/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { getStoryIds, getOfflineStoryIds } from "../services/apiHN";
import Story from "../components/Story";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";
import {
  MAX_STORIES,
  MESSAGE_NO_STORIES,
  MESSAGE_END_OF_STORIES,
} from "../constants";

function StoriesContainer({ setIsLoading, isLoading, reload }) {
  const [storyIds, setStoryIds] = useState([]);
  const { pageSize } = useInfiniteScroll();

  useEffect(() => {
    getStoryIds()
      .then((data) => {
        setStoryIds(data);
        setIsLoading(false);
      })
      .catch((error) => {
        getOfflineStoryIds().then((data) => {
          setStoryIds(data);
          setIsLoading(false);
        });
      });
  }, [reload]);

  return (
    <main className="app-stories">
      {storyIds.length < 1 && !isLoading && <p>{MESSAGE_NO_STORIES}</p>}
      {!isLoading &&
        storyIds
          .slice(0, pageSize)
          .map((storyId) => <Story key={storyId} storyId={storyId} />)}
      {pageSize >= MAX_STORIES && <p>{MESSAGE_END_OF_STORIES}</p>}
    </main>
  );
}

export default StoriesContainer;
